<template>
  <q-page>

    <div class="wrap_carousel">

<!--      <div class="q-gutter-md">-->

<!--        <q-carousel-->
<!--                v-model="slide"-->
<!--                transition-prev="jump-right"-->
<!--                transition-next="jump-left"-->
<!--                swipeable-->
<!--                animated-->
<!--                autoplay-->
<!--                control-color="white"-->
<!--                prev-icon="arrow_left"-->
<!--                next-icon="arrow_right"-->
<!--                navigation-icon="radio_button_unchecked"-->
<!--                navigation-->
<!--                padding-->
<!--                arrows-->
<!--                height="860px"-->
<!--                class="text-white shadow-1 rounded-borders"-->
<!--                infinite-->
<!--        >-->

<!--          <q-carousel-slide name="tv" class="column no-wrap flex-center slide2">-->
<!--            <div class="wrap_concept_text">-->
<!--              <p class="concept_text">-->
<!--                <span class="inner_concept_text">自然豊かな分譲地</span><br><span class="inner_concept_text">光といろとりどりの</span><br><span class="inner_concept_text">くつろぎあふれる住環境</span>-->
<!--              </p>-->
<!--            </div>-->
<!--          </q-carousel-slide>-->

<!--          <q-carousel-slide name="style" class="column no-wrap flex-center slide1">-->
<!--            <div class="wrap_concept_text font_sw">-->
<!--              <p class="concept_text">-->
<!--                <span class="inner_concept_text">採光を重視した南向き</span><br><span class="inner_concept_text">お客様の笑顔につながった</span><br><span class="inner_concept_text">格調高い外観</span>-->
<!--              </p>-->
<!--            </div>-->
<!--          </q-carousel-slide>-->

<!--          <q-carousel-slide name="layers" class="column no-wrap flex-center slide3">-->
<!--            <div class="wrap_concept_text">-->
<!--              <p class="concept_text">-->
<!--                <span class="inner_concept_text">都心へのアクセス良好</span><br><span class="inner_concept_text">夜には都心の夜景が楽しめる</span><br><span class="inner_concept_text">安らぎのプライベート空間</span>-->
<!--              </p>-->
<!--            </div>-->
<!--          </q-carousel-slide>-->
<!--        </q-carousel>-->
<!--      </div>-->
    </div>

    <div class="content_main">
      


      <SerchResult />


    </div>


<!--    <CasePromotion v-observe-visibility="{-->
<!--      callback: visibilityChanged,-->
<!--      throttle: 300,-->
<!--    }" />-->



  </q-page>
</template>

<style lang="stylus" scoped>
  .class-sample {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .my-card
    width 100%
    max-width 340px

  .pd-r-0
    padding-right 0

  .wrap_breadcrumbs
    min-width 200px
    font-size 13px

  //for slider
  .wrap_carousel
    // padding-bottom 9px
  .wrap_concept_text
    display flex
    justify-content center
    width 100%
    text-align center
    @media only screen and (max-width: 767px) {
      position relative
      top 3%
    }

  .concept_text
    display block
    margin-bottom 0
    //
    font-family 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN', 'Hiragino Mincho Pro', 'HGP明朝B', serif
    -webkit-font-feature-settings 'pkna'
    font-feature-settings 'pkna'
    -webkit-writing-mode vertical-rl
    -ms-writing-mode tb-rl
    writing-mode vertical-rl
    text-align left
    //
    font-size 42px
    line-height 1.5
    letter-spacing .06em
    white-space normal

  .slide1
    background-image url('https://www.projectdesign.jp/201712/images/gazou/120_1.jpg')
    background-repeat no-repeat
    background-size cover

  .slide2
    background-image url('https://images.keizai.biz/hongkong_keizai/headline/1532842104_photo.jpg')
    background-repeat no-repeat
    background-size cover

  .slide3
    background-image url('https://www.g-mark.org/media/award/2018/18G121000/18G121000_02_880x660.jpg?w=880&h=660&m=0')
    background-repeat no-repeat
    background-size cover

  .wrap_tab .q-item__section--main
    margin-left 10px

  @media only screen and (max-width: 767px) {
    .wrap_carousel .q-carousel {
      height 90vh !important
    }
    .concept_text {
      //
      font-size 32px
      line-height 1.5
      letter-spacing .06em
      white-space normal
    }
    .q-tab-panel {
      padding 0
    }
    .home_logo-item {
      height 48px
      width auto
      margin: 0 2px;
    }
    .inner_scroll {
      flex-direction column
    }
    .q-scroll-area {
      height auto !important
    }
    .q-pa-sm {
      width 100% !important
    }
  }

  .wrap_carousel {
    position relative
  }

  .logo_header {
    position absolute
    z-index 10
    @media only screen and (max-width: 767px) {
      // padding 24px 0 0 20px
    }
  }

  .inner_header
    position sticky
    @media only screen and (max-width: 767px) {
      display none
      position relative
      padding-left 12px
    }

</style>

<script>
import SerchResult from "../components/SearchResult";
export default {
  
  name: 'PageHome',
  components: {SerchResult},
  meta: {
    // sets document title
    title: '実績紹介',
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    titleTemplate: title => `${title} | 日本レーヴ株式会社`,

    // meta tags
    meta: {
      description: { name: 'description', content: '不動産の売買、コンサルティング、不動産投資、買取、賃貸、管理、リフォーム・リノベーションなど、不動産に関わるご相談はお気軽にお問い合わせください。' },
      keywords: { name: 'keywords', content: 'J-REVE' },
      equiv: { 'http-equiv': 'Content-Type', content: 'text/html; charset=UTF-8' }
    },

    // CSS tags
    link: {
      material: {
        rel: 'stylesheet', href: 'https://use.typekit.net/qmy6hoz.css',
      }
    },

    // <noscript> tags
    noscript: {
      default: 'This is content for browsers with no JS (or disabled JS)'
    }
  },

  data () {
    return {
      tab: 'mails',

      //for Carousel
      slide: 'style',

      //for rating
      ratingModel: 3,

      //for table
      columns: [
          {
              name: 'desc',
              required: true,
              label: '実績名',
              align: 'left',
              field: row => row.name,
              format: val => `${val}`,
              sortable: true
          },
          { name: 'calories', align: 'center', label: 'Calories', field: 'calories', sortable: true },
          { name: 'fat', label: 'Fat (g)', field: 'fat', sortable: true, style: 'width: 10px' },
          { name: 'carbs', label: 'Carbs (g)', field: 'carbs' },
          { name: 'protein', label: 'Protein (g)', field: 'protein' },
          { name: 'sodium', label: 'Sodium (mg)', field: 'sodium' },
          { name: 'calcium', label: 'Calcium (%)', field: 'calcium', sortable: true, sort: (a, b) => parseInt(a, 10) - parseInt(b, 10) },
          { name: 'iron', label: 'Iron (%)', field: 'iron', sortable: true, sort: (a, b) => parseInt(a, 10) - parseInt(b, 10) }
      ],
      data: [
          {
              name: '実績タイトルが入ります',
              calories: 159,
              fat: 6.0,
              carbs: 24,
              protein: 4.0,
              sodium: 87,
              calcium: '14%',
              iron: '1%'
          },
          {
              name: '実績タイトルが入ります',
              calories: 237,
              fat: 9.0,
              carbs: 37,
              protein: 4.3,
              sodium: 129,
              calcium: '8%',
              iron: '1%'
          },
          {
              name: '実績タイトルが入ります',
              calories: 262,
              fat: 16.0,
              carbs: 23,
              protein: 6.0,
              sodium: 337,
              calcium: '6%',
              iron: '7%'
          },
      ]
    }
  },

  methods: {
    //scroll event
    // visibilityChanged ({isVisible, entry}) {
    //     this.isVisible = isVisible
    // },
    window:onload = function() {

    },
  }
}
</script>
